export function thousandSeparator(
  amount: number | string,
  separator: string = " "
): string {
  return `${amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator)}`;
}

export function formatAmount(
  amount: number | string,
  currency: string = "FCFA"
): string {
  return `${thousandSeparator(amount)} ${currency}`;
}

export function ObjectToQueryParams(params: any) {
  if (!params) return "";

  let param = "";

  for (let ky in params) {
    const value = params[ky];
    if (!value && value !== 0 && value !== false) continue;
    if (param === "") {
      param += `?${ky}=${value}`;
    } else {
      param += `&${ky}=${value}`;
    }
  }

  return param;
}
